import { render, staticRenderFns } from "./IconTypeformPayment.vue?vue&type=template&id=456cb7ac&"
import script from "./IconTypeformPayment.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports